import { Table, Layout, Button } from "antd";
import { useParams } from "react-router-dom";
import {useIntl } from 'react-intl';
import { isEmptyObject } from "jquery";

import ExceptionPage from "../../pages/ExceptionPage";
import Loading from "../../pages/Loading";
import columns from "./columns";
import "../../styles/table.css";
import useDatasetContainer from "../../hooks/useDatasetContainer";
import BreadcrumbFolder from "./BreadcrumbFolder";
import SearchComponent from "./Search";

const { Content } = Layout;

const DatasetContainer = () => {
  const { id } = useParams<{ id?: string }>();
  const {
    datasetState,
    resourcesState,
    handleOnClick,
    handleOnClickBreadcrumb,
    currentPath,
    loadMoreOnClick,
    tableReference,
    onSearch,
    searchText,
    setSearchText,
  } = useDatasetContainer(id);
  const intl = useIntl();

  if (datasetState.datasets.error.status)
    return (
      <ExceptionPage
        status={datasetState.datasets.error.status}
        ticket={datasetState.datasets.error?.data?.ticket}
      />
    );

  return !isEmptyObject(resourcesState.resourceSelected?.name) &&
    datasetState.datasetRoutes.length > 0 ? (
    <Content
      ref={tableReference}
      style={{
        padding: "15px 50px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <BreadcrumbFolder
        onClick={handleOnClickBreadcrumb}
        routes={datasetState.datasetRoutes}
      />
      <SearchComponent
        onSearch={onSearch}
        searchText={searchText}
        onChangeValue={setSearchText}
      />
      <Table
        style={{ marginTop: 5 }}
        size="small"
        columns={columns(id, handleOnClick, currentPath)}
        dataSource={datasetState.datasets.data.elements}
        showSorterTooltip={false}
        pagination={false}
        /*pagination={{
          total: datasetState.datasets.data?.elements?.length,
          pageSize: pageSize,
          defaultCurrent: 1,
        }}*/
        loading={datasetState.datasets.loading}
        footer={() =>
          datasetState.datasets.data?.marker ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {
                <Button
                  size="small"
                  type="link"
                  block
                  onClick={(e) => loadMoreOnClick()}
                >
                  {intl.formatMessage({id: 'dataset.container.button.loadmore', defaultMessage:'Ver más'})}
                </Button>
                }
            </div>
          ) : (
            false
          )
        }
      />
    </Content>
  ) : (
    <Loading />
  );
};
export default DatasetContainer;
